export var SideBarType = {
  Left: 'left',
  Right: 'right'
};